import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class ReglasPublicacionService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/reglas-publicacion/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/profit-dev/src/app/shared/services/api/reglas-publicacion.service.ts